export default __webpack_public_path__ + "static/media/model-_3_safety_hero_mobile.ae71ae79.png";